import React, { useMemo, useState } from 'react';
import api from '../api/axios';

const Login = ({ onLogin, settings }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const companyName = useMemo(() => settings?.company_name || 'Pipeline Management', [settings?.company_name]);
  const logoUrl = useMemo(() => settings?.logo_url || null, [settings?.logo_url]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    console.log('Attempting login with:', formData.email);

    try {
      const response = await api.post('/api/auth/login', formData);
      console.log('Login successful:', response.data);
      onLogin(response.data.user, response.data.token);
    } catch (err) {
      console.error('Login error:', err.response?.data);
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="clean-login-container">
      <div className="login-card">
        <div className="login-header">
          {logoUrl ? (
            <div className="login-brand">
              <img src={logoUrl} alt="Company logo" className="brand-logo" />
            </div>
          ) : null}
          <h1 className="login-title">{companyName}</h1>
          <p className="login-subtitle">Business Pipeline & Project Management</p>
        </div>

        {error && (
          <div className="error-message">
            <span className="error-text">{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-input"
              required
              placeholder="admin@company.com"
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="form-input"
              required
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="login-button"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        
      </div>
    </div>
  );
};

export default Login;
